<template>
  <div class="TestCreate">
    <div class="content-header">
      <div class="container">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">Create Test</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/tests">Tests</router-link>
              </li>
              <li class="breadcrumb-item active">Create Test</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <section class="content">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-light">
              <div class="card-header">
                <h3 class="card-title">Create Test Account</h3>
              </div>
              <div class="card-body">
                <form @submit.prevent="handleSubmit">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="name">
                          Name
                          <span class="text-danger">*</span>
                        </label>
                        <input v-model="test.name" type="text" class="form-control" :class="{ 'is-invalid': $v.test.name.$error, 'is-valid': !$v.test.name.$invalid }" />
                        <div class="invalid-feedback">
                          <span v-if="!$v.test.name.required">Name is required.</span>
                          <span v-if="!$v.test.name.minLength">Name must be at least {{ $v.test.name.$params.minLength.min }} letters.</span>
                          <span v-if="!$v.test.name.maxLength">Name must be at most {{ $v.test.name.$params.maxLength.max }} letters.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="introduction">
                          Introduction
                          <span class="text-danger">*</span>
                        </label>
                        <textarea v-model="test.introduction" class="form-control" :class="{ 'is-invalid': $v.test.introduction.$error, 'is-valid': !$v.test.introduction.$invalid }"></textarea>
                        <div class="invalid-feedback">
                          <span v-if="!$v.test.introduction.required">Introduction is required.</span>
                          <span v-if="!$v.test.introduction.minLength">Introduction must be at least {{ $v.test.introduction.$params.minLength.min }} letters.</span>
                          <span v-if="!$v.test.introduction.maxLength">Introduction must be at most {{ $v.test.introduction.$params.maxLength.max }} letters.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="prerequisite">
                          Prerequisite
                          <span class="text-danger">*</span>
                        </label>
                        <vue-editor v-model="test.prerequisite" :editorToolbar="this.$store.state.editorToolbar" :class="{ 'is-invalid': $v.test.prerequisite.$error, 'is-valid': !$v.test.prerequisite.$invalid }"></vue-editor>
                        <input v-model="test.prerequisite" type="hidden" class="form-control" :class="{ 'is-invalid': $v.test.prerequisite.$error, 'is-valid': !$v.test.prerequisite.$invalid }" />
                        <div class="invalid-feedback">
                          <span v-if="!$v.test.prerequisite.required">Prerequisite is required.</span>
                          <span v-if="!$v.test.prerequisite.minLength">Prerequisite must be at least {{ $v.test.prerequisite.$params.minLength.min }} letters.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="description">
                          Description
                          <span class="text-danger">*</span>
                        </label>
                        <vue-editor v-model="test.description" :editorToolbar="this.$store.state.editorToolbar" :class="{ 'is-invalid': $v.test.description.$error, 'is-valid': !$v.test.description.$invalid }"></vue-editor>
                        <input v-model="test.description" type="hidden" class="form-control" placeholder="e.g. Mark" :class="{ 'is-invalid': $v.test.description.$error, 'is-valid': !$v.test.description.$invalid }" />
                        <div class="invalid-feedback">
                          <span v-if="!$v.test.description.required">Description is required.</span>
                          <span v-if="!$v.test.description.minLength">Description must be at least {{ $v.test.description.$params.minLength.min }} letters.</span>
                        </div>
                      </div>
                      <!-- end col-md-12 -->
                    </div>
                  </div>

                  <button :disabled="isDisabled" class="btn btn-danger" type="submit" id="submitButton">
                    <i class="far fa-paper-plane"></i>
                    Create
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import { VueEditor } from "vue2-editor";
import { required, email, numeric, minLength, maxLength } from "vuelidate/lib/validators";

export default {
  name: "TestCreate",
  data() {
    return {
      test: {
        name: "",
        introduction: "",
        prerequisite: "",
        description: "",
      },
      submitted: false,
      isDisabled: false,
    };
  },
  validations: {
    test: {
      name: { required, minLength: minLength(5), maxLength: maxLength(150) },
      introduction: { required, minLength: minLength(25), maxLength: maxLength(300) },
      prerequisite: { required, minLength: minLength(25) },
      description: { required, minLength: minLength(25) },
    },
  },
  components: {
    VueEditor,
  },
  created() {
    document.title = "Create Test - Coregrade LMS";
    this.$store.commit("SET_LAYOUT", "admin-layout");
  },
  mounted() {
    //this.$store.dispatch("Tests");
  },
  computed: {
    s3() {
      return this.$store.state.s3;
    },
  },
  methods: {
    handleSubmit(e) {
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isDisabled = false;
        return;
      }

      this.submitted = true;
      this.isDisabled = true;

      axios.post("/authoring/tests/create", this.test).then((res) => {
        this.submitted = false;
        this.isDisabled = false;
        if (res.data.status === "success") {
          this.$v.$reset();
          this.test = {};
          this.$swal("Done!", res.data.message, "success");
          this.$router.push("/tests");
        } else {
          this.$swal("Nope!", res.data.message, "error");
        }
      });
    },
  },
};
</script>
